/* eslint-disable arrow-body-style */
import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import MeshMavenTitleComp from 'screens/performanceReview/components/ContinuousFeedback/Drawers/common/MeshMaven/MeshMavenTitleComp';

import { CollapseSidepanel, Details } from 'assets/assetsV1/iconComponents';

import { DrawerFooter, primaryDrawerWidth } from 'uiToolkitV1/BottomDrawer';
import { Button as ButtonV1 } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { updateAddViolationDrawer, useSelectAddViolationDrawerData } from '../slice/addViolation.slice';
import { MeshMavenAnalyze } from './MeshMavenAnalyze';
import { MeshMavenRephrase } from './MeshMavenRephrase';

const CloseSecondaryPanelIcon = (props) => <CollapseSidepanel {...props} color="#666666 !important" />;

const MeshMavenPanel = ({
  onSecondaryPanelClose,
  onCancel,
}: {
  onSecondaryPanelClose: () => void;
  onCancel?: () => void;
}) => {
  const { rephrasedDescription, rephrasedDescriptionHtml } = useSelectAddViolationDrawerData();
  const dispatch = useDispatch();
  const onUseContent = () => {
    dispatch(
      updateAddViolationDrawer({
        description: rephrasedDescription,
        descriptionHtml: rephrasedDescriptionHtml,
        isSecondaryPanelOpen: false,
      })
    );
  };

  return (
    <Flex w={primaryDrawerWidth} flexDir="column" border="4px solid #EBEFF3" borderRadius="8px" h="100%">
      <Box
        display="flex"
        w="100%"
        p="12px"
        pb="8px !important"
        alignItems="center"
        sx={{
          button: {
            height: '20px',
            width: '20px',
          },
        }}
      >
        <TextBodyMedium bold mr="auto">
          <MeshMavenTitleComp />
        </TextBodyMedium>
        <ButtonV1 StartIcon={CloseSecondaryPanelIcon} variant="tertiary" onClick={onSecondaryPanelClose} />
      </Box>
      <Box overflow="auto" overflowX="hidden">
        <Box p="8px">
          <MeshMavenRephrase />
        </Box>
        <Box p="8px">
          <MeshMavenAnalyze />
        </Box>
      </Box>
      <DrawerFooter h="72px" backgroundColor="neutral.F5F7F9" mt="auto">
        <Flex bgColor="neutral.F5F7F9" justifyContent="space-between" w="100%">
          <ButtonV1 variant="tertiary" onClick={onCancel}>
            Cancel
          </ButtonV1>
          <ButtonV1 StartIcon={Details} startIconProps={{ fill: 'none' }} onClick={onUseContent}>
            Use this content
          </ButtonV1>
        </Flex>
      </DrawerFooter>
    </Flex>
  );
};

export { MeshMavenPanel };
